import { dbService } from './db';
import { Form, Link, useSubmit, useLoaderData } from "react-router";
import { Combobox, ComboboxInput, ComboboxOption, ComboboxOptions, Field, Label, Input, Fieldset, Textarea } from '@headlessui/react'
import React, { useState } from 'react'
import clsx from 'clsx'

export function meta({ }) {
  return [
    { title: "DX Sales App - Site Visit" },
    { name: "description", content: "Welcome to DX Sales App - Site Visit" },
  ];
}

export async function clientLoader({ }) {
  let db = await dbService.createDB();
  let customers = (await db.getAll("customers"));
  return { customers };
}

export function SiteVisit({ }) {

  const { customers } = useLoaderData();
  const [selectedCustomer, setSelectedCustomer] = useState({});
  const [query, setQuery] = useState('');

  const filteredCustomers =
    query === ''
      ? customers.slice(0, 10)
      : customers.filter((customer) => {
        return customer.name.toLowerCase().includes(query.toLowerCase())
      }).slice(0, 10)

  return (
    <>
      <h1 className="text-lg">New Site Visit</h1>
      <Form action="/sitevisits" method="post">
        <div>
          <Field>
            <Label>Customer</Label>
            <Combobox value={selectedCustomer} onChange={(value) => setSelectedCustomer(value)} onClose={() => setQuery('')}>

              <div className="flex items-center rounded-md bg-white pl-3 outline-1 -outline-offset-1 outline-gray-800 has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-red-800">
                <ComboboxInput
                  aria-label="Customer"
                  displayValue={(customer) => customer?.name}
                  onChange={(event) => setQuery(event.target.value)}
                  className={clsx('block min-w-0 grow py-1.5 pr-3 pl-1 text-base text-gray-900 placeholder:text-gray-400 focus:outline-none sm:text-sm/6')}
                />
              </div>
              <ComboboxOptions
                anchor="bottom"
                transition
                className={"bg-white w-[var(--input-width)]  p-1 [--anchor-gap:var(--spacing-1)] empty:invisible transition duration-100 ease-in data-[leave]:data-[closed]:opacity-0"}>
                {filteredCustomers.map((customer) => (
                  <ComboboxOption key={customer.id} value={customer}>
                    {customer?.name}
                  </ComboboxOption>
                ))}
              </ComboboxOptions>
            </Combobox>
          </Field>

          {selectedCustomer?.name &&
            <>
              <Fieldset>
                <Field >
                  <Label>Customer Name: </Label>
                  <div className="flex items-center rounded-md bg-white pl-3 outline-1 -outline-offset-1 outline-gray-800 has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-red-800">
                    <Input name="full_name" type="text" value={selectedCustomer?.name} className={""} disabled={true} />
                  </div>
                </Field>

                <Field >
                  <Label>Customer Number: </Label>
                  <div className="flex items-center rounded-md bg-white pl-3 outline-1 -outline-offset-1 outline-gray-800 has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-red-800">
                    <Input name="full_name" type="text" value={selectedCustomer.customerNumber} className={""} disabled={true} />
                  </div>
                </Field>

                <Field >
                  <Label>Product Group: </Label>
                  <Input name="full_name" type="text" className={"min-w-full flex items-center rounded-md bg-white pl-3 outline-1 -outline-offset-1 outline-gray-800 has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-red-800"} />
                </Field>

                <Field>
                  <Label>Notes: </Label>
                  <Textarea name="notes" className={"min-w-full flex items-center rounded-md bg-white pl-3 outline-1 -outline-offset-1 outline-gray-800 has-[input:focus-within]:outline-2 has-[input:focus-within]:-outline-offset-2 has-[input:focus-within]:outline-red-800"} />
                </Field>
              </Fieldset>

              <button type="submit" className="mt-2 mr-1 group relative flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-800">Submit</button>
            </>
          }
        </div >
      </Form>
    </>
  );
}

export async function saveSiteVisit(request) {
  let formData = await request.formData();
  
  
  console.log(`Notes: ${formData.get("notes")}`);
}